import React, {Component} from "react";
import TopNav from "../components/TopNavNew";
import Header from "../components/Header";
import axios from "axios";
import buildAPIUrl from "../../../Services/UrlBuilder";
import ClipLoader from "react-spinners/ClipLoader";
import {ScaleLoader} from "react-spinners";
import ReactToPrint from "react-to-print";

class CurrentAuction extends Component{
    state = {
        active:"",
        salvages:[],
        bids:"",
        loading:true
    }
    async componentDidMount(){
        setInterval(()=>{
            const  response = axios.get(buildAPIUrl('get-active-users')).then((res)=>{
                this.setState({
                    active: res.data
                })
            });
            const response1 = axios.get(buildAPIUrl(`company-current-auction/${localStorage.getItem('item')}`)).then((res1)=>{
                console.log(res1)
                this.setState({
                    salvages: res1.data.salvages,
                    bids: res1.data.salvages.bids,
                })
            })
        }, 5000)
        setInterval(()=>{
            this.setState({
                loading:false
            })
        },3000)
    }
    render() {
        return (
            <>
                <TopNav />
                <Header />
                <div className="container mt-5 auctions">
                    <div className="row">
                        <div className="col-md-4">
                            <div className="card">
                                <div className="card-header">
                                    <h6>Active Bidders</h6>
                                </div>
                                <div className="card-body">

                                    <table className="table">
                                        <tr>
                                            <th>User ID</th>
                                            <th>Status</th>
                                        </tr>
                                        {
                                            this.state.active ? <>
                                                    {
                                                        this.state.active.map((activeu)=>(
                                                            <tr>
                                                                <td>{
                                                                    "RBDU" +  activeu.id
                                                                }</td>
                                                                <td className="text-success">
                                                                    Online
                                                                </td>
                                                            </tr>
                                                        ))
                                                    }
                                                </>

                                                : <p>There are no active bidders</p>
                                        }
                                    </table>


                                </div>
                            </div>
                        </div>
                        <div className="col-md-8">
                            <div className="card">
                                <div className="card-header">
                                    <div className="row">
                                        <div className="col-md-12">
                                            <h6 className="">Current Auction</h6>
                                        </div>
                                        <div className="col-md-6">
                                            <ReactToPrint
                                                trigger={() => {
                                                    // NOTE: could just as easily return <SomeComponent />. Do NOT pass an `onClick` prop
                                                    // to the root node of the returned component as it will be overwritten.
                                                    return <button className="btn btn-success">Print</button>;
                                                }}
                                                content={() => this.componentRef}
                                            />
                                        </div>
                                    </div>

                                </div>
                                <div className="card-body p-0 m-0">
                                    {
                                        this.state.loading ? <>
                                                <div className="container-fluid d-flex justify-content-center">
                                                    <ClipLoader color={"red"} loading={ScaleLoader} size={100}/>
                                                </div>
                                            </> :
                                            <table ref={el => (this.componentRef = el)} className="table table-hover table-striped table-borderless ">
                                                <tr className="options-table-header">
                                                    <th>Reg Number</th>
                                                    <th>Make</th>
                                                    <th>Model</th>
                                                    <th style={{width: "50%"}}>Bids</th>
                                                </tr>
                                                {
                                                    this.state.salvages ? <>
                                                        {
                                                            this.state.salvages.map((salavge) => (
                                                                <tr>
                                                                    <td>{salavge.regNo}</td>
                                                                    <td>{salavge.make}</td>
                                                                    <td>{salavge.model}</td>
                                                                    <td>{
                                                                        salavge.bids ? <ol>
                                                                            {
                                                                                salavge.bids.map((bid) => (
                                                                                    <li className="bid-list"><span
                                                                                        className="text-black" style={{
                                                                                        fontWeight: "700",
                                                                                        color: "green"
                                                                                    }}> {bid.bidAmount} </span><span> {bid.name} </span>
                                                                                        <i style={{fontSize: "12px"}}>{new Date(bid.created_at).toLocaleDateString()} {new Date(bid.created_at).toLocaleTimeString()}</i>
                                                                                    </li>
                                                                                ))
                                                                            }
                                                                        </ol> : <p>There are no bids</p>
                                                                    }</td>
                                                                </tr>
                                                            ))
                                                        }

                                                    </> : <p>There is no active auction running</p>
                                                }
                                            </table>
                                    }
                                </div>

                            </div>
                        </div>
                    </div>
                </div>
            </>
        )
    }
}
export default CurrentAuction